const initialState = {
    orders: {
        bookTitle: "",
        author: "",
        bookCover: "sunset",
        purchaser: "",
        furigana: "",
        email: "",
        noteUrl: [],
        identification: false,
        birthOfDay: "",
        sex: "",
        howDidChermoKnow: "",
        otherSpecificContent: "",
    },
    shippingInfo: {
        receiver: "",
        furigana: "",
        telephone: "",
        postCode: "",
        prefecture: "",
        city: "",
        address: "",
        apartmentAndRoom: ""
    },
    orderStatus: {
        orderId: "",
        orderStatus: "",
        created_at: ""
    },
    inquiry: {
        name: "",
        email: "",
        content: "",
        createdAt: ""
    }
};

export default initialState;